import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/use-auth';
import { LoadingBlock } from '@/components/atoms';

// Redirects to sign-in (preserving intended destination) when there's no user once auth resolves.
export function AuthGuard() {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <LoadingBlock label="Checking your session…" />;
  if (!user) return <Navigate to="/account/sign-in" state={{ from: location.pathname }} replace />;
  return <Outlet />;
}
